import { Controller } from '@hotwired/stimulus'
import Imask from 'imask'

export default class ImaskController extends Controller {
  static values = { type: String }

  connect () {
    switch (this.typeValue) {
      case 'phone':
        Imask(this.element, {
          mask: '+1 (000) 000-0000',
          lazy: true,
          country: 'USA',
          blocks: {
            num: {
              mask: Number
            }
          }
        })
        break
      case 'year':
        Imask(this.element, {
          mask: Imask.MaskedRange,
          from: 1900,
          to: 2099,
          maxLength: 4
        })
    }
  }
}
